<template>
  <div class="mission-result-container">
    <!-- 导航栏 -->
    <div class="custom-nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-left" @click="back()">
          <i class="nav-bar-arrow van-icon van-icon-arrow-left"></i>
        </div>
        <div class="nav-bar-title">
          {{$t('game.missionResult')}}
        </div>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="main-content">
      <!-- 顶部信息卡片 -->
      <div class="info-card">
        <div class="top-section">
          <h1 class="mission-name">{{name}}</h1>
          <span class="mission-period">{{$t('game.day')}}{{expect}}{{$t('game.period')}}</span>
        </div>
      </div>

      <!-- 状态卡片 -->
      <div class="status-card">
        <div class="status-left">
          <h1 class="points-amount">{{money}}{{$t('points')}}</h1>
          <span class="points-label">{{$t('game.workPoints')}}</span>
        </div>
        <div class="status-divider"></div>
        <div class="status-right">
          <h1 class="status-text" :class="statusClass">
            {{statusText}}
          </h1>
        </div>
      </div>

      <!-- 订单信息卡片 -->
      <div class="order-card">
        <p class="order-item">
          <span class="order-label">{{$t('orderContentLabel')}}</span>
          <span class="order-value">{{formattedTouzhu}}</span>
        </p>
        <p class="order-item">
          <span class="order-label">{{$t('game.orderTime')}}</span>
          <span class="order-value">{{time}}</span>
        </p>
      </div>

      <!-- 详情卡片 -->
      <div class="detail-card">
        <div class="detail-title">
          {{$t('game.detail')}}
        </div>
        <div class="table-container">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{$t('game.content')}}</th>
                <th>{{$t('game.amount')}}</th>
                <th>{{$t('game.result')}}</th>
                <th>{{$t('game.time')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,key) in list" :key="key">
                <td>{{getTypeText(v.type)}}</td>
                <td>{{v.money}} Points</td>
                <td :class="getResultClass(v.is_win)">{{getResultText(v.is_win)}}</td>
                <td>{{v.update_time || v.create_time || '--'}}</td>
              </tr>
              <tr v-if="list.length === 0" class="empty-row">
                <td colspan="4">{{$t('common.nodata')}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[],
      name:'',
      expect:'',
      lid:'',
      money:'',
      touzhu:'',
      time:'',
      status:'',
    };
  },
  computed: {
    statusClass() {
      return this.status == 1 ? 'status-completed' : 'status-waiting';
    },
    statusText() {
      return this.status == 1 ? this.$t('game.giftCompleted') : this.$t('waitingResultLabel');
    },
    formattedTouzhu() {
      if (!this.touzhu) return '--';
      return String(this.touzhu)
        .split(/[,，、\s]+/)
        .filter(Boolean)
        .map(type => this.getTypeText(type))
        .join(', ');
    }
  },
  methods: {
    back(){
      this.$router.push({path:'GameRecord'})
    },
    getVideoInfo(){
      if (!this.$route.query.expect) return;
      this.$http({
        method: 'get',
        data:{lid:this.$route.query.lid,expect:this.$route.query.expect},
        url: 'user_get_game_detail'
      }).then(res=>{
        const payload = res.data || {};
        let rows = Array.isArray(payload) ? payload : (payload.list || payload.data || payload.details || []);
        if (!Array.isArray(rows) && rows && typeof rows === 'object') rows = Object.values(rows);
        this.applyRows(rows);
      }).catch(() => {})
    },
    applyRows(rows) {
      if (!Array.isArray(rows)) return;
      if (rows.length || this.list.length === 0) this.list = rows;
      if (!rows.length) return;
      const first = rows[0] || {};
      this.name = this.name || first.name || (first.lottery && first.lottery.name) || '';
      this.expect = this.expect || first.expect || first.issue || '';
      this.time = this.time || first.create_time || first.created_at || '';
      this.status = this.status !== '' ? this.status : first.status;
      if (!this.money) this.money = rows.reduce((sum, row) => sum + Number(row.money || row.amount || 0), 0);
      this.touzhu = rows.map(row => row.type).filter(Boolean).join(',');
    },
    getTypeText(type) {
      if (!type) return '--';
      const rawType = String(type).trim();
      const normalizedType = rawType.toUpperCase();
      const labels = {
        BESAR: this.$t('betOptions.rose') + ' 🌹',
        KECIL: this.$t('betOptions.lily') + ' ⚜️',
        GENAP: this.$t('betOptions.fireworks') + ' 🎆',
        GANJIL: this.$t('betOptions.balloon') + ' 🎈',
        '大': this.$t('betOptions.rose') + ' 🌹',
        '小': this.$t('betOptions.lily') + ' ⚜️',
        '双': this.$t('betOptions.fireworks') + ' 🎆',
        '單': this.$t('betOptions.balloon') + ' 🎈',
        '单': this.$t('betOptions.balloon') + ' 🎈'
      };
      return labels[normalizedType] || labels[rawType] || rawType;
    },
    getResultClass(isWin) {
      switch(Number(isWin)) {
        case 1: return 'result-win';
        case 2: return 'result-failed';
        default: return 'result-waiting';
      }
    },
    getResultText(isWin) {
      switch(Number(isWin)) {
        case 1: return this.$t('game.win');
        case 2: return this.$t('game.missionFailed');
        default: return this.$t('waitingResultLabel');
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      let cached = {};
      try { cached = JSON.parse(sessionStorage.getItem('currentGameRecord') || '{}'); } catch (e) { cached = {}; }
      this.name = this.$route.query.name;
      this.expect = this.$route.query.expect;
      this.money = this.$route.query.money;
      this.lid = this.$route.query.lid;
      this.touzhu = this.$route.query.touzhu || '';
      this.time = this.$route.query.time;
      this.status = this.$route.query.status;
      if (cached && String(cached.expect || '') === String(this.expect || '')) {
        this.name = this.name || cached.name || '';
        this.money = this.money || cached.money || '';
        this.time = this.time || cached.create_time || '';
        this.status = this.status !== undefined ? this.status : cached.status;
        this.applyRows(Array.isArray(cached.data) ? cached.data : []);
      }
      this.getVideoInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.mission-result-container {
  min-height: 100vh;
  background: #f5f5f5;
}

/* 导航栏样式 */
.custom-nav-bar {
  height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.nav-bar-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.nav-bar-left {
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.2);
  }
}

.nav-bar-arrow {
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
}

.nav-bar-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

/* 主要内容区域 */
.main-content {
  padding: 1rem;
}

/* 卡片通用样式 */
.info-card,
.status-card,
.order-card,
.detail-card {
  background: white;
  border-radius: 12px;
  border: 1.5px solid #e8e8e8;
  padding: 1.2rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

/* 顶部信息卡片 */
.info-card {
  .top-section {
    text-align: center;
    
    .mission-name {
      font-size: 1.2rem;
      font-weight: 600;
      color: #333;
      margin-bottom: 0.5rem;
    }
    
    .mission-period {
      font-size: 0.9rem;
      color: #969799;
    }
  }
}

/* 状态卡片 */
.status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  
  .status-left,
  .status-right {
    flex: 1;
    text-align: center;
  }
  
  .status-divider {
    width: 1px;
    height: 3rem;
    background: #f2f2f5;
  }
  
  .points-amount {
    font-size: 1.2rem;
    font-weight: 600;
    color: #667eea;
    margin-bottom: 0.5rem;
  }
  
  .points-label {
    font-size: 0.9rem;
    color: #969799;
  }
  
  .status-text {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    
    &.status-completed {
      color: #10b981;
    }
    
    &.status-waiting {
      color: #ef4444;
    }
  }
}

/* 订单信息卡片 */
.order-card {
  .order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.8rem 0;
    border-bottom: 1px solid #f2f2f5;
    
    &:last-child {
      border-bottom: none;
    }
    
    .order-label {
      font-size: 0.9rem;
      color: #666;
    }
    
    .order-value {
      font-size: 0.95rem;
      color: #333;
      font-weight: 500;
    }
  }
}

/* 详情卡片 */
.detail-card {
  .detail-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid #f2f2f5;
  }
}

.table-container {
  overflow-x: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  
  th, td {
    padding: 0.8rem 0.5rem;
    text-align: center;
    border: 1px solid #e8e8e8;
  }
  
  th {
    background: rgba(102, 126, 234, 0.05);
    color: #667eea;
    font-weight: 600;
    font-size: 0.8rem;
  }
  
  td {
    color: #333;
  }
  
  .result-win {
    color: #10b981;
    font-weight: 500;
  }
  
  .result-failed {
    color: #ef4444;
    font-weight: 500;
  }
  
  .result-waiting {
    color: #f59e0b;
    font-weight: 500;
  }
}

/* 响应式设计 */
@media (max-width: 320px) {
  .main-content {
    padding: 0.8rem;
  }
  
  .info-card,
  .status-card,
  .order-card,
  .detail-card {
    padding: 1rem;
    margin-bottom: 0.8rem;
  }
  
  .detail-table {
    font-size: 0.8rem;
    
    th, td {
      padding: 0.6rem 0.3rem;
    }
  }
}

@media (min-width: 768px) {
  .main-content {
    padding: 1.5rem;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .info-card,
  .status-card,
  .order-card,
  .detail-card {
    padding: 1.5rem;
    margin-bottom: 1.2rem;
  }
}

/* Date Love Club - task result */
.mission-result-container {
  color: #ead8b3;
  background: linear-gradient(rgba(2, 4, 7, .9), rgba(2, 4, 7, .97)),
    url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed;
}

.custom-nav-bar {
  height: 3.8rem;
  background: rgba(3, 5, 8, .97);
  border-bottom: 1px solid rgba(224, 185, 105, .5);
}

.nav-bar-arrow,
.nav-bar-title {
  color: #f1cf77;
}

.nav-bar-arrow {
  font-size: 1.45rem;
}

.nav-bar-title {
  font-size: 1.32rem;
  font-weight: 800;
}

.main-content {
  padding: 1rem .85rem 2rem;
}

.info-card,
.status-card,
.order-card,
.detail-card {
  padding: 1.15rem;
  margin-bottom: .9rem;
  border: 1px solid rgba(222, 183, 104, .42);
  border-radius: 1rem;
  background: linear-gradient(145deg, rgba(17, 20, 25, .98), rgba(6, 9, 13, .98));
  box-shadow: 0 .8rem 1.7rem rgba(0, 0, 0, .3);
}

.info-card .top-section .mission-name {
  color: #f2d483;
  font-size: 1.35rem;
  font-weight: 800;
}

.info-card .top-section .mission-period {
  color: #b9ad99;
  font-size: .95rem;
}

.status-card .status-divider {
  background: rgba(222, 183, 104, .25);
}

.status-card .points-amount {
  color: #f0ca68;
  font-size: 1.35rem;
}

.status-card .points-label {
  color: #b9ad99;
  font-size: .92rem;
}

.status-card .status-text {
  font-size: 1.08rem;
}

.order-card .order-item {
  border-color: rgba(222, 183, 104, .18);
}

.order-card .order-item .order-label {
  color: #c7baa5;
  font-size: .94rem;
}

.order-card .order-item .order-value {
  max-width: 68%;
  color: #f0d18a;
  font-size: .94rem;
  text-align: right;
  overflow-wrap: anywhere;
}

.detail-card .detail-title {
  color: #f0ce77;
  font-size: 1.15rem;
  text-align: center;
  border-color: rgba(222, 183, 104, .2);
}

.detail-table {
  font-size: .88rem;
}

.detail-table th,
.detail-table td {
  min-width: 5.3rem;
  padding: .85rem .45rem;
  border-color: rgba(222, 183, 104, .24);
}

.detail-table th {
  color: #f0cc70;
  background: rgba(201, 149, 59, .12);
  font-size: .88rem;
}

.detail-table td {
  color: #ddd0b8;
  background: rgba(4, 7, 11, .72);
}

.detail-table .empty-row td {
  color: #948a7b;
  padding: 2rem .5rem;
}

@media (max-width: 430px) {
  .mission-result-container {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    background-attachment: scroll;
  }

  .custom-nav-bar {
    height: auto;
    min-height: 58px;
    padding-top: env(safe-area-inset-top);
  }

  .nav-bar-content {
    min-height: 58px;
    padding: 0 10px;
  }

  .nav-bar-left {
    min-width: 44px;
    padding: 9px;
  }

  .nav-bar-title {
    min-width: 0;
    padding-right: 44px;
    font-size: 17px;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .main-content {
    min-width: 0;
    padding: 12px 10px max(22px, env(safe-area-inset-bottom));
  }

  .info-card,
  .status-card,
  .order-card,
  .detail-card {
    min-width: 0;
    padding: 15px 13px;
    border-radius: 16px;
  }

  .mission-name,
  .mission-period,
  .points-amount,
  .points-label,
  .status-text,
  .order-label,
  .order-value {
    max-width: 100%;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .status-card {
    gap: 10px;
  }

  .status-card .status-left,
  .status-card .status-right {
    min-width: 0;
  }

  .order-card .order-item {
    min-width: 0;
    gap: 12px;
    align-items: flex-start;
  }

  .order-card .order-item .order-label {
    min-width: 0;
    flex: 1 1 42%;
  }

  .order-card .order-item .order-value {
    min-width: 0;
    max-width: 58%;
    flex: 1 1 58%;
    white-space: normal;
  }

  .table-container {
    width: 100%;
    max-width: 100%;
    padding-bottom: 5px;
    overflow-x: hidden;
  }

  .detail-table {
    width: 100%;
    min-width: 0;
    table-layout: fixed;
  }

  .detail-table th,
  .detail-table td {
    min-width: 0;
    padding: 9px 4px;
    font-size: 12px;
    white-space: normal;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 350px) {
  .status-card {
    flex-direction: column;
  }

  .status-card .status-left,
  .status-card .status-right {
    width: 100%;
  }

  .status-card .status-divider {
    width: 100%;
    height: 1px;
  }

  .order-card .order-item {
    flex-direction: column;
    gap: 5px;
  }

  .order-card .order-item .order-label,
  .order-card .order-item .order-value {
    width: 100%;
    max-width: 100%;
    text-align: left;
  }
}
</style>
